import { Card, Tabs, Tab } from "@mui/material";
import MDBox from "components/MDBox";
import LiveTripsBoard from "map/components/LiveTripsBoard";
import { useState } from "react";
import DashboardCharts from "./DashboarCharts";
import TripOperationsRisk from "./TripOperationsRisk";

const Home = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <>
      <Card>
        <Tabs value={activeTab} onChange={handleChange} aria-label="basic tabs">
          <Tab
            className={activeTab == 0 ? "tab tab-active" : "tab"}
            label="Live Trips"
            id="live-trips-tab"
            aria-controls="live-trips-tab-panel"
          />
          <Tab
            className={activeTab == 1 ? "tab tab-active" : "tab"}
            label="Trip Alerts"
            id="trip-tab"
            aria-controls="trip-tab-panel"
          />
          <Tab
            className={activeTab == 2 ? "tab tab-active" : "tab"}
            label="Metrics"
            id="map-tab"
            aria-controls="map-tab-panel"
          />
        </Tabs>

        {/* The board sizes itself against the viewport and carries its own internal padding, so
            it sits outside the padded box the other two panels share -- wrapping it would push
            its bottom edge off screen. It is also mounted only while selected, rather than
            hidden like the others: a display:none Mapbox canvas initialises at zero size and
            comes back blank, and an unmounted board is not polling every 60s in the background. */}
        <div id="live-trips-tab-panel" role="tabpanel" hidden={activeTab !== 0}>
          {activeTab === 0 ? <LiveTripsBoard /> : null}
        </div>

        {/* p:0 on the Live Trips tab -- both children are hidden there, and a padded empty box
            would still sit under the board as a strip of dead space. */}
        <MDBox sx={{ p: activeTab === 0 ? 0 : 4 }}>
          <div id="trip-tab-panel" role="tabpanel" hidden={activeTab !== 1}>
            <TripOperationsRisk />
          </div>
          <div id="map-tab-panel" role="tabpanel" hidden={activeTab !== 2}>
            <DashboardCharts />
          </div>
        </MDBox>
      </Card>
    </>
  );
};
export default Home;
